import { render } from "./DocumentClassExportInterface.vue?vue&type=template&id=c7ddee5c&scoped=true&ts=true"
import script from "./DocumentClassExportInterface.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportInterface.vue?vue&type=script&lang=ts"

import "./DocumentClassExportInterface.vue?vue&type=style&index=0&id=c7ddee5c&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ddee5c"]])

export default __exports__